import type { KnowledgeArticleTranslations } from './articles.types';

export const KNOWLEDGE_BASE_ARTICLES_HI: KnowledgeArticleTranslations = {
  pickup: {
    title: 'संग्रह आदेश',
    summary: "पिकअप ऑर्डर बनाएँ, ट्रैक करें और प्रबंधित करें।",
    content:
      'संग्रह आदेश आपकी साइटों से कचरा एकत्र करने का समय निर्धारित करने के लिए उपयोग होते हैं। साइडबार से «संग्रह आदेश» खोलें ताकि नया आदेश बनाएँ, सूची देखें या उनकी स्थिति ट्रैक करें।\n\nचरण-दर-चरण निर्देशों के लिए नीचे एक मार्गदर्शिका चुनें।',
  },
  'view-pickup-orders-list': {
    title: "पिकअप ऑर्डर सूची देखें",
    summary: "ऑर्डर तालिका खोलें, खोजें और पिकअप अनुरोध ब्राउज़ करें।",
    content:
      "1. साइडबार में «पिकअप ऑर्डर» खोलें।\n\n2. मुख्य तालिका में आपके संगठन के पिकअप ऑर्डर ID, संग्रह स्थल, स्थिति और तिथियों के साथ दिखते हैं।\n\n3. ID या संग्रह स्थल से ऑर्डर खोजने के लिए तालिका के ऊपर खोज बॉक्स का उपयोग करें।\n\n4. अधिक पंक्तियाँ देखने के लिए स्क्रॉल करें और नीचे पेजिनेशन का उपयोग करें।\n\nसुझाव: स्थिति चिप्स और तिथि फ़िल्टर परिणाम सीमित करते हैं — संबंधित गाइड देखें।",
  },
  'create-pickup-order-outlet': {
    title: 'नया संग्रह आदेश बनाएँ',
    summary: "कचरा पिकअप निर्धारित करने की चरण-दर-चरण गाइड।",
    content:
      '1. साइडबार से «संग्रह आदेश» खोलें फिर «संग्रह आदेश बनाएँ» (या संग्रह आदेश पृष्ठ पर + बटन दबाएँ)।\n\n2. आदेश विवरण:\n   • सामग्री प्रकार (अनिवार्य) — कचरे की श्रेणी और माप इकाई स्वतः भर जाती है।\n\n3. स्थान और कंटेनर:\n   • संग्रह स्थल (अनिवार्य)\n   • चयनित स्थल पर कंटेनर\n   • भराव स्तर — पूर्ण, तीन चौथाई, आधा, या एक चौथाई भरा\n\n4. «सहेजें» पर क्लिक करें। आदेश सूची में «लंबित» स्थिति के साथ दिखाई देगा।',
  },
  material: {
    title: 'सामग्री',
    summary: "पिकअप ऑर्डर के लिए सामग्री प्रकार जोड़ें, संपादित करें और प्रबंधित करें।",
    content:
      'सामग्री प्रकार जोड़ने और संपादित करने का तरीका जानने के लिए नीचे से एक मार्गदर्शिका चुनें।',
  },
  'add-material-type': {
    title: 'सामग्री प्रकार जोड़ें',
    summary: "पिकअप ऑर्डर के लिए कचरा सामग्री प्रकार पंजीकृत करें।",
    content:
      '1. साइडबार से «पुनर्चक्रण» खोलें फिर «सामग्री प्रकार»।\n\n2. «सामग्री जोड़ें» (ऊपर दाएँ) पर क्लिक करें।\n\n3. सामग्री का नाम, श्रेणी और माप इकाई दर्ज करें (जैसे: किग्रा, टन, थैले)।\n\n4. «सहेजें» पर क्लिक करें। सामग्री संग्रह आदेश बनाते समय उपलब्ध हो जाएगी।',
  },
  container: {
    title: 'कंटेनर',
    summary: "कचरा कंटेनर जोड़ें, प्रबंधित करें और ट्रैक करें।",
    content:
      'कंटेनर प्रबंधित करने का तरीका जानने के लिए नीचे से एक मार्गदर्शिका चुनें।',
  },
  'add-container': {
    title: 'नया कंटेनर जोड़ें',
    summary: "संग्रह स्थल पर कचरा कंटेनर पंजीकृत करें।",
    content:
      '1. साइडबार से «कंटेनर» खोलें फिर «कंटेनर सूची»।\n\n2. «कंटेनर जोड़ें» (ऊपर दाएँ) पर क्लिक करें।\n\n3. कंटेनर विवरण भरें: नाम, सामग्री प्रकार, संग्रह स्थल, स्थिति और अन्य आवश्यक फ़ील्ड।\n\n4. «सहेजें» पर क्लिक करें। कंटेनर सूची में दिखाई देगा और संग्रह आदेश बनाते समय चुना जा सकेगा।',
  },
  'collection-site': {
    title: 'संग्रह स्थल',
    summary: "कचरा संग्रह स्थल जोड़ें, संपादित करें और प्रबंधित करें।",
    content:
      'संग्रह स्थल प्रबंधित करने का तरीका जानने के लिए नीचे से एक मार्गदर्शिका चुनें।',
  },
  'add-collection-site': {
    title: 'नया संग्रह स्थल जोड़ें',
    summary: "वह स्थान बनाएँ जहाँ कचरा एकत्र किया जाता है।",
    content:
      '1. साइडबार से «कंटेनर» खोलें फिर «संग्रह स्थल»।\n\n2. «स्थल जोड़ें» (ऊपर दाएँ) पर क्लिक करें।\n\n3. स्थल का नाम, पता और अन्य आवश्यक विवरण दर्ज करें।\n\n4. «सहेजें» पर क्लिक करें। अब आप कंटेनर को इस स्थल से जोड़ सकते हैं और संग्रह आदेश फ़ॉर्म में इसे चुन सकते हैं।',
  },

  truck: {
    title: 'ट्रक',
    summary: "वाहन जोड़ें, बेड़े की स्थितियाँ समझें और ट्रक प्रबंधित करें।",
    content:
      'वाहन बेड़े का प्रबंधन करने का तरीका जानने के लिए नीचे से एक मार्गदर्शिका चुनें।',
  },
  'add-vehicle': {
    title: 'वाहन जोड़ें',
    summary: "पूरे विवरण के साथ नया ट्रक या बेड़ा वाहन पंजीकृत करें।",
    content:
      '1. साइडबार से «ट्रक» खोलें ताकि «बेड़ा प्रबंधन» तक पहुँच मिले।\n\n2. «वाहन जोड़ें» (ऊपर दाएँ) पर क्लिक करें।\n\n3. फ़ॉर्म भरें:\n   • नंबर प्लेट (अरबी और अंग्रेज़ी)\n   • वाहन का नाम (अनिवार्य)\n   • क्षमता और क्षमता इकाई\n   • वाहन प्रकार, मॉडल, VIN, खाली वज़न और ईंधन खपत\n   • स्थिति — यदि वाहन असाइनमेंट के लिए तैयार है तो «उपलब्ध» चुनें\n\n4. «सहेजें» पर क्लिक करें। वाहन बेड़ा तालिका में दिखाई देगा।',
  },
  driver: {
    title: 'चालक',
    summary: "ड्राइवर पंजीकृत करें, प्रोफ़ाइल देखें और ट्रक असाइनमेंट प्रबंधित करें।",
    content:
      'चालकों का प्रबंधन करने का तरीका जानने के लिए नीचे से एक मार्गदर्शिका चुनें।',
  },
  'add-driver': {
    title: 'चालक जोड़ें',
    summary: "लाइसेंस और व्यक्तिगत विवरण के साथ ड्राइवर खाता बनाएँ।",
    content:
      '1. साइडबार से «चालक» खोलें।\n\n2. «चालक जोड़ें» (ऊपर दाएँ) पर क्लिक करें।\n\n3. खाता अनुभाग: ईमेल, पासवर्ड और उसकी पुष्टि।\n\n4. व्यक्तिगत अनुभाग: नाम, फ़ोन नंबर, लिंग, राष्ट्रीयता और अन्य।\n\n5. चालक और वाहन अनुभाग: ड्राइविंग लाइसेंस नंबर, समाप्ति तिथि और वाहन पंजीकरण नंबर।\n\n6. «सहेजें» पर क्लिक करें। चालक तालिका में दिखाई देगा।',
  },
  'understanding-notifications': {
    title: 'सूचनाएँ',
    summary: "प्लेटफ़ॉर्म अलर्ट सक्षम करने, पढ़ने और प्रबंधित करने का तरीका।",
    content:
      'ब्राउज़र सूचनाएँ सक्षम करें:\nजब अनुमति का अनुरोध आए तो «अनुमति दें» पर क्लिक करें ताकि ऐप के बाहर आदेश और प्लेटफ़ॉर्म अपडेट मिल सकें।\n\nसूचनाएँ देखें:\n1. ऊपरी पट्टी में घंटी आइकन पर क्लिक करें।\n2. पैनल में अपठित सूचनाएँ शीर्षक, संदेश और समय के साथ दिखाई देती हैं।\n3. किसी सूचना पर क्लिक करें ताकि उसे पढ़ा हुआ चिह्नित किया जाए।\n4. «सभी को पढ़ा हुआ चिह्नित करें» का उपयोग करें ताकि सभी अपठित सूचनाएँ एक साथ साफ़ हो जाएँ।\n\nमहत्वपूर्ण:\n• घंटी पर दिखाई देने वाली संख्या अपठित सूचनाओं की गिनती बताती है।',
  },
  'pickup-order-statuses': {
    title: 'संग्रह आदेश की स्थिति',
    summary: "ऑपरेशन के दौरान प्रत्येक ऑर्डर स्थिति का अर्थ।",
    content:
      'आप «संग्रह आदेश» सूची से वर्तमान स्थिति देख सकते हैं। आदेश की प्रगति के साथ स्थिति स्वतः अपडेट होती है।\n\n• लंबित — आदेश बनाया गया है और प्रसंस्करण या असाइनमेंट की प्रतीक्षा है।\n• परिवहन में — कचरा संग्रह या वितरण जारी है।\n• पूर्ण — आदेश सफलतापूर्वक पूरा हो गया।\n• रद्द — आदेश रद्द कर दिया गया और पूरा नहीं होगा।',
  },
  'filter-pickup-orders-by-date': {
    title: 'तिथि के अनुसार आदेश फ़िल्टर करें',
    summary: "निर्दिष्ट तिथि सीमा में ऑर्डर खोजें।",
    content:
      '1. साइडबार से «संग्रह आदेश» खोलें।\n\n2. «तिथि के अनुसार फ़िल्टर» अनुभाग पर जाएँ।\n\n3. प्रारंभ और समाप्ति तिथि निर्धारित करें।\n\n4. सूची फ़िल्टर करने के लिए «तिथियाँ लागू करें» पर क्लिक करें।\n\n5. फ़िल्टर हटाने और डिफ़ॉल्ट दृश्य पर लौटने के लिए «तिथियाँ साफ़ करें» पर क्लिक करें।',
  },
  'container-fill-level': {
    title: 'कंटेनर भराव स्तर',
    summary: "कंटेनर के लिए सही भराव स्तर चुनने का तरीका।",
    content:
      '«संग्रह आदेश बनाएँ» फ़ॉर्म में कंटेनर चुनने पर भराव स्तर बताना अनिवार्य हो जाता है।\n\nउपलब्ध विकल्प:\n• पूर्ण — कंटेनर पूरी तरह भरा है\n• तीन चौथाई भरा — लगभग 75% भरा\n• आधा भरा — लगभग 50% भरा\n• एक चौथाई भरा — लगभग 25% भरा\n\nवास्तविक स्थिति के निकटतम स्तर चुनें ताकि संचालन और चालक बेहतर योजना बना सकें।',
  },
  'container-statuses': {
    title: 'कंटेनर की स्थिति',
    summary: "प्रत्येक कंटेनर स्थिति का अर्थ और कब उपयोग करें।",
    content:
      '«कंटेनर सूची» से कंटेनर जोड़ते या संपादित करते समय स्थिति निर्धारित या देखी जा सकती है।\n\n• संग्रह के लिए तैयार — कंटेनर तैयार है और कचरा एकत्र किया जा सकता है।\n• संग्रह की प्रतीक्षा — संग्रह निर्धारित है या कार्रवाई की प्रतीक्षा है।\n• खाली — एकत्र करने के लिए कोई कचरा नहीं।\n• रखरखाव में — कंटेनर अस्थायी रूप से सेवा से बाहर है।\n• तैयारी में — कंटेनर सेटअप किया जा रहा है।\n• निष्क्रिय — कंटेनर वर्तमान में उपयोग में नहीं है।',
  },
  'print-container-qr': {
    title: 'कंटेनर QR कोड प्रिंट करें',
    summary: "फ़ील्ड उपयोग के लिए QR लेबल बनाएँ और प्रिंट करें।",
    content:
      '1. «कंटेनर» ← «कंटेनर सूची» खोलें।\n\n2. तालिका में कंटेनर खोजें।\n\n3. उसकी पंक्ति में QR आइकन पर क्लिक करें।\n\n4. प्रिंट संवाद से लेबल प्रिंट करें।\n\nलेबल को स्थल पर कंटेनर पर चिपकाएँ ताकि पहचान और मैदानी स्कैनिंग आसान हो।',
  },
  'edit-material-type': {
    title: 'सामग्री प्रकार संपादित या हटाएँ',
    summary: "रीसाइक्लिंग सेटिंग्स से सामग्री प्रकार अपडेट या हटाएँ।",
    content:
      '1. «पुनर्चक्रण» ← «सामग्री प्रकार» खोलें।\n\n2. संपादन के लिए: संपादन आइकन पर क्लिक करें, विवरण बदलें, फिर «सहेजें» पर क्लिक करें।\n\n3. हटाने के लिए: हटाएँ आइकन पर क्लिक करें, फिर कार्रवाई की पुष्टि करें।\n\nचेतावनी: सक्रिय संग्रह आदेशों से जुड़ा सामग्री प्रकार न हटाएँ। पहले उन आदेशों को पूरा या अपडेट करें।',
  },
  'edit-or-delete-container': {
    title: 'कंटेनर संपादित या हटाएँ',
    summary: "सूची से कंटेनर अपडेट या हटाएँ।",
    content:
      '1. «कंटेनर» ← «कंटेनर सूची» खोलें।\n\n2. संपादन के लिए: संपादन आइकन पर क्लिक करें, विवरण बदलें, फिर «सहेजें» पर क्लिक करें।\n\n3. हटाने के लिए: हटाएँ आइकन पर क्लिक करें, फिर कार्रवाई की पुष्टि करें।\n\nचेतावनी: कंटेनर संग्रह आदेशों से जुड़ा हो सकता है। हटाने से पहले पुष्टि करें।',
  },
  'edit-or-delete-collection-site': {
    title: 'संग्रह स्थल संपादित या हटाएँ',
    summary: "संग्रह स्थल अपडेट या हटाएँ।",
    content:
      '1. «कंटेनर» ← «संग्रह स्थल» खोलें।\n\n2. स्थल कार्ड पर «संपादित करें» या «हटाएँ» पर क्लिक करें।\n\n3. यदि कहा जाए तो हटाने की पुष्टि करें।\n\nचेतावनी: स्थल कंटेनर और संग्रह आदेशों से जुड़ा हो सकता है। हटाने से पहले लिंक की समीक्षा करें।',
  },
  'truck-statuses': {
    title: 'वाहन की स्थिति',
    summary: "प्रत्येक बेड़ा वाहन स्थिति का अर्थ और कब उपयोग करें।",
    content:
      'प्रत्येक वाहन की स्थिति «बेड़ा प्रबंधन» तालिका में दिखाई देती है। जोड़ते या संपादित करते समय इसे अपडेट किया जा सकता है।\n\n• उपलब्ध — वाहन चालक या यात्रा के लिए असाइनमेंट के लिए तैयार है।\n• अनुपलब्ध — वाहन वर्तमान में उपयोग नहीं किया जा सकता।\n• परिवहन में — वाहन सड़क पर है।\n• लोडिंग / अनलोडिंग — वाहन लोडिंग या अनलोडिंग स्थल पर है।\n• रखरखाव में — वाहन मरम्मत या सेवा में है।\n\nसुझाव: अस्थायी बंदी पर «अनुपलब्ध» या «रखरखाव में» रखें, हटाएँ नहीं।',
  },
  'view-driver-details': {
    title: 'चालक विवरण देखें',
    summary: "ड्राइवर प्रोफ़ाइल, लाइसेंस जानकारी और निर्धारित ट्रक खोलें।",
    content:
      '1. साइडबार से «चालक» खोलें।\n\n2. तालिका में चालक खोजें।\n\n3. विवरण खोलने के लिए देखें (आँख) आइकन पर क्लिक करें।\n\n4. संवाद में दिखाया जाता है: खाता जानकारी, व्यक्तिगत विवरण, लाइसेंस जानकारी और असाइन किया गया ट्रक यदि हो।\n\n5. संपादन के लिए: संवाद में «संपादित करें» पर क्लिक करें, या पंक्ति क्रिया मेनू का उपयोग करें।\n\nयदि ट्रक «असाइन नहीं» दिखाए तो क्रिया मेनू से «ट्रक पर असाइन करें» चुनें।',
  },
  'edit-or-delete-vehicle': {
    title: 'वाहन संपादित या हटाएँ',
    summary: "वाहन विवरण अपडेट करें या बेड़े से ट्रक हटाएँ।",
    content:
      'वाहन संपादित करें:\n1. «ट्रक» ← «बेड़ा प्रबंधन» खोलें।\n2. पंक्ति में संपादन आइकन पर क्लिक करें, या विवरण खोलकर «संपादित करें» चुनें।\n3. फ़ील्ड बदलें और «सहेजें» पर क्लिक करें।\n\nवाहन हटाएँ:\n1. पंक्ति में हटाएँ आइकन पर क्लिक करें, या विवरण से हटाएँ।\n2. हटाने की पुष्टि करें।\n\nचेतावनी: यदि वाहन चालक को असाइन है या सक्रिय यात्रा से जुड़ा है तो हटाने से संचालन प्रभावित हो सकते हैं।',
  },
  'edit-or-delete-driver': {
    title: 'चालक संपादन और ट्रक असाइनमेंट',
    summary: "ड्राइवर जानकारी अपडेट करें और ट्रक असाइनमेंट प्रबंधित करें।",
    content:
      'चालक विवरण संपादित करें:\n1. «चालक» खोलें।\n2. पंक्ति क्रिया मेनू से «चालक संपादित करें» चुनें।\n3. विवरण बदलें और «सहेजें» पर क्लिक करें।\n\nविकल्प: देखें आइकन पर क्लिक करें फिर विवरण से «संपादित करें» चुनें।\n\nट्रक असाइन करें:\n1. क्रिया मेनू से «ट्रक पर असाइन करें» चुनें।\n2. उपलब्ध ट्रक (जिस पर चालक असाइन नहीं) चुनें और पुष्टि करें।\n\nअसाइनमेंट रद्द करें:\n1. क्रिया मेनू से «ट्रक से असाइनमेंट रद्द करें» चुनें (केवल असाइन होने पर दिखाई देता है)।\n2. कार्रवाई की पुष्टि करें।',
  },
};
